import { CanvasFactory, Context2dFactory } from "@visactor/vrender-core";

export function createModule(CanvasConstructor, ContextConstructor) {
    return bindingContainer => {
        var _a, _b;
        const hasCanvasFactory = !!(null === (_a = bindingContainer.getNamed) || void 0 === _a ? void 0 : _a.call(bindingContainer, CanvasFactory, CanvasConstructor.env)), hasContextFactory = !!(null === (_b = bindingContainer.getNamed) || void 0 === _b ? void 0 : _b.call(bindingContainer, Context2dFactory, ContextConstructor.env));
        hasCanvasFactory || bindingContainer.bind(CanvasFactory).toDynamicValue((() => params => new CanvasConstructor(params))).whenTargetNamed(CanvasConstructor.env), 
        hasContextFactory || bindingContainer.bind(Context2dFactory).toDynamicValue((() => (params, dpr) => new ContextConstructor(params, dpr))).whenTargetNamed(ContextConstructor.env);
    };
}
//# sourceMappingURL=create-canvas-module.js.map